const routers = [
    {
        path: '/garden_activity',
        name: 'garden_activity',
        meta: {
            exp: '园区活动',
            requireAuth: false
        },
        component: () => import('@/views/garden_activity/index.vue'),
    },
    {
        path: '/garden_activity_details',
        name: 'garden_activity_details',
        meta: {
            exp: '园区活动详情',
            requireAuth: false
        },
        component: () => import('@/views/garden_activity/garden_activity_details/index.vue'),
    },
    {
        path: '/garden_activity_sing',
        name: 'garden_activity_sing',
        meta: {
            exp: '园区活动活动报名',
            requireAuth: true
        },
        component: () => import('@/views/garden_activity/sign/index.vue'),
    },
]
export default routers